import { useHeaderAtom } from "@RHCommerceDev/hooks/atoms/useHeaderAtom";
import useDidMountEffect from "@RHCommerceDev/hooks/useDidMountEffect";
import useGetNavigation from "@RHCommerceDev/hooks/useGetNavigation";
import useLocale from "@RHCommerceDev/hooks/useLocale";
import { cn } from "@RHCommerceDev/utils/cn";
import React from "react";
import { Typography } from "unstyled-ui-components";
import parsedCatalogNavigation from "utils/parseCatalogNavigationData";
import NavigationDropdown from "./catalogNavigationDropdown";
import memoize from "utils/memoize";

const CatalogNavigationV2 = () => {
  const {
    catalogNavigation,
    saleCatalogNavigation,
    refetchCatalogNavigation,
    refetchSaleCatalogNavigation
  } = useGetNavigation();
  const locale = useLocale();

  const navigationData = parsedCatalogNavigation(
    catalogNavigation,
    saleCatalogNavigation
  );
  const categoryArray = navigationData?.childCategories;

  const isFrenchMontreal = locale === "fr-CA" || locale === "fr-FR";
  const {
    state,
    closeCategoryDropdown,
    openCategoryDropdown,
    setSelectedCategoryIndex
  } = useHeaderAtom();

  useDidMountEffect(() => {
    refetchCatalogNavigation();
    refetchSaleCatalogNavigation();
  }, [locale]);

  return (
    <>
      {/* Navigation is hidden below md */}
      <div className="hidden w-full flex-nowrap justify-between p-0 md:flex">
        {categoryArray?.map((category, index) =>
          category?.childCategories === null ? (
            <a
              key={index}
              href={category?.targetUrl || ""}
              className="flex items-end text-inherit no-underline"
            >
              <Typography
                variant="default"
                fontFamily={
                  index === state.selectedCategoryIndex ? "rhcRoman" : "rhc"
                }
                fontWeight="normal"
                className={cn(
                  "text-base uppercase leading-[1.5em] tracking-[0.05em]",
                  {
                    "opacity-30":
                      state.selectedCategoryIndex !== -1 &&
                      index !== state.selectedCategoryIndex,
                    "tracking-[5%] md:text-[11px] lg:text-[12.5px] xl:text-[14px]":
                      isFrenchMontreal
                  }
                )}
              >
                {category.displayName ?? ""}
              </Typography>
            </a>
          ) : (
            <button
              key={index}
              onClick={() => {
                if (index === state.selectedCategoryIndex) {
                  closeCategoryDropdown();
                  setSelectedCategoryIndex(-1);
                } else {
                  openCategoryDropdown();
                  setSelectedCategoryIndex(index);
                }
              }}
              className="p-0 text-inherit"
            >
              <Typography
                variant="default"
                fontFamily={
                  index === state.selectedCategoryIndex ? "rhcRoman" : "rhc"
                }
                fontWeight="normal"
                className={cn(
                  "text-base uppercase leading-[1.5em] tracking-[0.05em]",
                  {
                    "opacity-30":
                      state.selectedCategoryIndex !== -1 &&
                      index !== state.selectedCategoryIndex,
                    "tracking-[5%] md:text-[11px] lg:text-[12.5px] xl:text-[14px]":
                      isFrenchMontreal
                  }
                )}
              >
                {category.displayName ?? ""}
              </Typography>
            </button>
          )
        )}
      </div>

      <NavigationDropdown
        key={state.selectedCategoryIndex}
        selectedCategory={categoryArray?.[state.selectedCategoryIndex]}
      />
    </>
  );
};

export default memoize(CatalogNavigationV2);
